import apiClient from './client';
import type {
  AssignDifficultyCandidatesResponse,
  AssignDifficultyCandidateItem,
  AssignDifficultyFilter,
  DifficultyRecord,
} from '../types/overcallingAssignDifficulty';

// API client for the Overcalling Assign Level of Difficulty page (012).
// Matches contracts/overcalling-assign-difficulty-api.md.

export const overcallingAssignDifficultyApi = {
  async getCandidates(filter: AssignDifficultyFilter): Promise<AssignDifficultyCandidatesResponse> {
    const response = await apiClient.get<AssignDifficultyCandidatesResponse>(
      '/overcalling-assign-difficulty/candidates',
      { params: { filter } }
    );
    return response.data;
  },

  async getByTableResultId(tableresultId: number): Promise<AssignDifficultyCandidateItem> {
    // skipRedirectOn404 lets the page render a friendly "not found" message
    // (mirrors the 009 pattern for ?id=N deep links).
    const response = await apiClient.get<AssignDifficultyCandidateItem>(
      `/overcalling-assign-difficulty/candidate/by-id/${tableresultId}`,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      { skipRedirectOn404: true } as any
    );
    return response.data;
  },

  async assignDifficulty(
    tableresultId: number,
    difficultyLevel: number
  ): Promise<DifficultyRecord> {
    const response = await apiClient.post<DifficultyRecord>(
      `/overcalling-assign-difficulty/hands/${tableresultId}/assign`,
      { difficultyLevel }
    );
    return response.data;
  },
};
